import { isoInDays, isTaskOverdue, localDate, todayIso } from '@/lib/dealFormat'
import type { Task } from '@/api/tasks'

/** Open tasks in the order they need doing — what's late, then today, then the week ahead. */
export type TaskGroup = 'overdue' | 'today' | 'week' | 'later' | 'undated'

export const GROUP_TITLE: Record<TaskGroup, string> = {
  overdue: 'Overdue',
  today: 'Due today',
  week: 'Next 7 days',
  later: 'Later',
  undated: 'No due date',
}
export const GROUP_ORDER: TaskGroup[] = ['overdue', 'today', 'week', 'later', 'undated']

/** Which group an open task falls in, judged on the reader's own calendar like every due date on screen. */
export function groupOf(t: Pick<Task, 'dueAt'>): TaskGroup {
  if (!t.dueAt) return 'undated'
  if (isTaskOverdue(t.dueAt)) return 'overdue'
  const day = localDate(t.dueAt)
  if (day === todayIso()) return 'today'
  return day <= isoInDays(7) ? 'week' : 'later'
}
